export default "__VITE_ASSET__BXvdqlxk__"